import { render, staticRenderFns } from "./LadyCard.vue?vue&type=template&id=5859d63c&scoped=true"
import script from "./LadyCard.vue?vue&type=script&lang=js"
export * from "./LadyCard.vue?vue&type=script&lang=js"
import style0 from "./LadyCard.vue?vue&type=style&index=0&id=5859d63c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5859d63c",
  null
  
)

export default component.exports